import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import axios, { AxiosInstance } from 'axios';
import { KeycloakAuthService } from '../core/services/keycloak-auth.service';
import { ApiConfigService } from '../core/services/api-config.service';

export interface OptimizedPrompt {
  OptimizedPrompt: string;
  PromptAnalysis: string;
}

export enum DataTypes {
  String,
  Integer,
  Boolean,
  Dictionary,
  List
}

export interface SupportedModels {
  LLM: string[];
  Agent: string[];
  Embed: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ToolsService {
  private api: AxiosInstance;
  private platformId = inject(PLATFORM_ID);
  private authService = inject(KeycloakAuthService);
  private apiConfig = inject(ApiConfigService);

  constructor() {
    this.api = axios.create({
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Add request interceptor to dynamically set baseURL and include OAuth token
    this.api.interceptors.request.use((config) => {
      // Dynamically construct baseURL on each request to get current tenantId
      if (isPlatformBrowser(this.platformId)) {
        const baseUrl = this.apiConfig.getApiBaseUrl();
        const tenantId = this.apiConfig.getTenantId();
        config.baseURL = `${baseUrl}/${tenantId}/`;
      }

      const token = this.authService.accessToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  async optimizePrompt(prompt: string, modelId: string): Promise<OptimizedPrompt | null> {
    try {
      console.log('Optimizing prompt for model:', modelId);
      const response = await this.api.post('/optimizeprompt', {
        ModelId: modelId,
        Prompt: prompt
      });

      return response.data;
    } catch (error: any) {
      console.error('Failed to optimize prompt:', error);
      throw error;
    }
  }

  async getBedrockModels(): Promise<SupportedModels | null> {
    try {
      const response = await this.api.get('/bedrock/models');
      return response.data;
    } catch (error: any) {
      console.error('Failed to get Bedrock models:', error);
      throw error;
    }
  }
}
